import React from 'react';
import { UserGreatingTemplate } from '@ideoz/ui';

export default function UserGreating(): JSX.Element {
  // This is the web version of UserGreating
  // It uses the template from @ideoz/ui and adds web-specific logic
  return <UserGreatingTemplate />;
}
